import React from 'react';
import Icon from '../../../components/AppIcon';
import { FAQ_ITEMS } from '../../../config/faqContent.mjs';

export { FAQ_ITEMS };

const FAQSection = () => {
  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-teal-50 border border-teal-200 rounded-full text-xs font-semibold text-teal-700 mb-5">
            <Icon name="CircleHelp" size={13} />
            <span>Questions, answered</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-gray-900 leading-tight mb-4">
            Everything you need to know before you start
          </h2>
          <p className="text-base sm:text-lg text-gray-500">
            Clear answers about forms, pricing, publishing, and growing your response volume.
          </p>
        </div>

        <div className="divide-y divide-gray-200 border-y border-gray-200">
          {FAQ_ITEMS.map((item) => (
            <article key={item.question} className="py-5">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
                {item.question}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {item.answer}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;